// ts-nocheck
// eslint-disable-next-line no-unused-vars
import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import { useProduct } from './product-context';

const Denominations = () => {
  const { activeProduct, setActiveVariant, setHasChanged, activeVariant } =
    useProduct();

  const denominationsName = activeProduct?.tags.find((tag) =>
    tag.toLowerCase().includes('gift card'),
  );

  const denominations = denominationsName
    ? activeProduct.options[0].values?.sort((a, b) => {
        const priceA = a.split('-')[0].replace('$', '');
        const priceB = b.split('-')[0].replace('$', '');

        return parseInt(priceA) - parseInt(priceB);
      })
    : null;

  const handleChange = (e) => {
    const activeIndex = e.target.selectedIndex;

    setActiveVariant(activeProduct.variants.edges[activeIndex].node);
  };

  useEffect(() => {
    setHasChanged(true);
  }, []);

  return (
    <>
      {denominations && (
        <div>
          <select
            onChange={handleChange}
            className="denominations w-full border-1 border-text-1 rounded-[6px] mb-[30px]"
          >
            {denominations.map((denomination) => (
              <option
                selected={activeVariant?.title === denomination}
                value={denomination}
              >
                {denomination}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

export default Denominations;
